const GENERIC_CLIPBOARD_NAME = /^image\.\w+$/i;

export const isAccepted = (file: File, accept: string): boolean => accept.split(',').includes(file.type);

// Browsers name every pasted screenshot "image.png"; give each a distinct, timestamped name.
export const renamePasted = (file: File, index: number): File => {
  if (file.name && !GENERIC_CLIPBOARD_NAME.test(file.name)) return file;
  const ext = file.type.split('/')[1] ?? 'png';
  const stamp = new Date().toISOString().slice(0, 19).replace(/[-:]/g, '').replace('T', '-');
  const suffix = index > 0 ? `-${index + 1}` : '';
  return new File([file], `pasted-image-${stamp}${suffix}.${ext}`, { type: file.type });
};
